import { Container, Row, Col } from 'react-bootstrap';
import Button from '../../../../ntisui/Atoms/Buttons';
import { ButtonVariant } from '../../../template/types/IHeader';
import { litrals } from '../../../../../constants/Litrals';
import { IConfirmStep1 } from '../types/IConfirmStep1';
import './_ConfirmSubscriptionStep1.scss';

function ConfirmSubscriptionStep1({
  onCancelClick,
  onConfirmClick,
  mainContent,
  subContent,
}: IConfirmStep1) {
  return (
    <Container
      data-testid="confirm-subscription-step1"
      className="confirm-subscription-step1"
    >
      <Row>
        <Col>
          <h3>{litrals.confirmSubscription}</h3>
          <p>{mainContent}</p>
          <p>{subContent}</p>
        </Col>
      </Row>

      <Row>
        <Col sm={12} md={6}>
          <Button
            variant={ButtonVariant.Primary}
            className="confirm-button"
            label={litrals.confirmSubscription}
            onClick={() => {
              onConfirmClick();
            }}
          />
        </Col>
        <Col sm={12} md={6}>
          <Button
            variant={ButtonVariant.OutlinePrimary}
            className="cancel-button"
            label={litrals.cancelSubscription}
            onClick={() => {
              onCancelClick();
            }}
          />
        </Col>
      </Row>
    </Container>
  );
}

export default ConfirmSubscriptionStep1;
